import React from 'react';
import styled from 'styled-components';
import { Container, Heading2 } from '../components/common';
import { colors, media } from '../utils/styles';

const TextPage = ({ pageContext: { heading, content } }) => {
  return (
    <Wrap>
      <Container>
        <Heading>{heading}</Heading>
        <Content dangerouslySetInnerHTML={{ __html: content.html }} />
      </Container>
    </Wrap>
  );
};

const Content = styled.div`
  font-size: 16px;
  line-height: 25px;
  max-width: 100%;
  width: 800px;
  margin: 0 auto;
  a {
    color: ${colors.pink};
    text-decoration: underline;
  }
  p {
    margin: 0 0 30px;
  }
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-weight: 700;
    line-height: 1.4;
    margin: 0 0 20px;
  }
  h2 {
    font-size: 32px;
  }
  h3 {
    font-size: 28px;
  }
  h4 {
    font-size: 24px;
  }
  h5 {
    font-size: 20px;
  }
  h6 {
    font-size: 16px;
  }
  ${media.phone} {
    h2 {
      font-size: 28px;
    }
    h3 {
      font-size: 24px;
    }
    h4 {
      font-size: 20px;
    }
    h5 {
      font-size: 18px;
    }
  }
`;

const Wrap = styled.div`
  padding: 200px 0 150px;
  ${media.phone} {
    padding: 180px 0 40px;
  }
`;

const Heading = styled(Heading2)`
  margin: 0 0 50px;
`;

export default TextPage;
